<div>
<mat-nav-list class="sidebar-list" dense>
  <div *ngFor="let config of configs">
    <div *ngIf="!config.disabled">
        <ng-container *ngIf="config.route" >
          <a mat-list-item class="sidebar-root"
             *ngIf="!config.disabled"
             [disabled]="config.disabled" [ngClass]="config.disabled ? 'not-allowed' : ''"
             [routerLink]="[config.route]"
             routerLinkActive="sidebar-item-active"
             [routerLinkActiveOptions]="{exact: true}">
            <mat-icon class="sidebar-root-picked-icon" >{{config.icon}}</mat-icon> <span> {{config.title}}</span>
          </a>
        </ng-container>
        <ng-container *ngIf="!config.route">
          <a mat-list-item (click)="toggleListElements(config)" class="sidebar-root">
            <mat-icon class="sidebar-root-picked-icon">{{config.icon}}</mat-icon> <span> {{config.title}}</span>
            <mat-icon class="sidebar-root-icon" *ngIf="config.show">expand_more</mat-icon>
            <mat-icon class="sidebar-root-icon" *ngIf="!config.show">chevron_right</mat-icon>
          </a>
          <div *ngIf="config.show">
            <ng-container *ngFor="let item of config.items">
              <div
                class="sidebar-subroute-container"
                *ngIf="!item.hidden"
                [ngClass]="item.disabled ? 'not-allowed' : ''"
              >
                <a
                  class="sidebar-item"
                  mat-list-item
                  [routerLink]="[item.route]"
                  routerLinkActive="sidebar-item-active"
                  [routerLinkActiveOptions]="{exact: true}"
                  [disabled]="item.disabled"
                >
                  <mat-icon matListIcon> {{ item.icon }} </mat-icon>
                  <span>
                    {{item.title}}
                    <ng-container *ngIf="(item.badge | async)">[{{item.badge | async}}]</ng-container>
                  </span>
                </a>
              </div>
            </ng-container>
          </div>
          <mat-divider></mat-divider>
        </ng-container>
      </div>
  </div>


</mat-nav-list>
<img src="assets/logo.png" alt="" class="sidebar-logo">
</div>
